(function () {
  'use strict';

  function initPCS(sectionEl, config) {
    var moneyFormat = config.moneyFormat;

    function formatMoney(cents) {
      if (!cents && cents !== 0) return '';
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      var amount = (cents / 100).toFixed(2);
      var amountNoDec = Math.floor(cents / 100).toString();
      var amountComma = (cents / 100).toFixed(2).replace('.', ',');
      return moneyFormat
        .replace('{{amount_with_comma_separator}}', amountComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDec.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
        .replace('{{amount_no_decimals}}', amountNoDec)
        .replace('{{amount}}', amount);
    }

    var t = config.t;

    /* ── State ── */
    var steps = config.steps;
    var totalSteps = steps.length;
    var currentStepIdx = 0;
    var onSummary = false;
    var selections = {};
    var disabledOptions = {};
    var stepEnabled = [];
    var optisPrices = {};

    /* ── DOM refs ── */
    var stepEls = sectionEl.querySelectorAll('[data-pcs-step]');
    var progressDots = sectionEl.querySelectorAll('[data-pcs-progress-dot]');
    var progressItems = sectionEl.querySelectorAll('[data-pcs-progress-item]');
    var lineFills = sectionEl.querySelectorAll('[data-pcs-line-fill]');
    var backBtn = sectionEl.querySelector('[data-pcs-back]');
    var nextBtn = sectionEl.querySelector('[data-pcs-next]');
    var cartWrap = sectionEl.querySelector('[data-pcs-cart]');
    var navWrap = sectionEl.querySelector('[data-pcs-nav]');
    var addToCartBtn = sectionEl.querySelector('[data-pcs-add-to-cart]');
    var cartBackBtn = sectionEl.querySelector('[data-pcs-cart-back]');
    var priceEl = sectionEl.querySelector('[data-pcs-price]');
    var priceCompareEl = sectionEl.querySelector('[data-pcs-price-compare]');
    var cartPriceEl = sectionEl.querySelector('[data-pcs-cart-price]');
    var reviewEl = sectionEl.querySelector('[data-pcs-review]');
    var controlsEl = sectionEl.querySelector('[data-pcs-controls]');
    var variantErrorEl = sectionEl.querySelector('[data-pcs-variant-error]');
    var variantErrorText = sectionEl.querySelector('[data-pcs-variant-error-text]');

    /* ── Init ── */
    function hasOptisConfig() {
      for (var i = 0; i < steps.length; i++) {
        var s = steps[i];
        if (s.optionList) {
          for (var j = 0; j < s.optionList.length; j++) {
            if (s.optionList[j].optis) return true;
          }
        }
        if (s.fabricOptionList) {
          for (var j = 0; j < s.fabricOptionList.length; j++) {
            if (s.fabricOptionList[j].optis) return true;
          }
        }
        if (s.imageOptions) {
          for (var j = 0; j < s.imageOptions.length; j++) {
            if (s.imageOptions[j].optis) return true;
          }
        }
        if (s.colorOptions && s.colorOptions.optis) return true;
      }
      return false;
    }

    function waitForOptis(callback) {
      if (document.querySelector('input[key^="po_"]')) {
        callback();
        return;
      }
      var resolved = false;
      var loaderEl = document.createElement('div');
      loaderEl.className = 'pcs__optis-loader';
      loaderEl.innerHTML = '<span class="pcs__optis-spinner"></span>';
      sectionEl.appendChild(loaderEl);

      function done() {
        if (resolved) return;
        resolved = true;
        if (observer) observer.disconnect();
        if (loaderEl.parentNode) loaderEl.parentNode.removeChild(loaderEl);
        sectionEl.classList.remove('pcs--loading');
        callback();
      }

      var observer = new MutationObserver(function() {
        if (document.querySelector('input[key^="po_"]')) {
          setTimeout(done, 150);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(done, 6000);
    }

    function init() {
      for (var i = 0; i < totalSteps; i++) {
        stepEnabled[i] = true;
      }

      initDefaults();
      applyDefaultSelectionsUI();
      initColorSwatches();
      initAppLinkQR();
      evaluateAllConditions();
      evaluateAllConditions();
      updateUI();
      showMediaBySelections();
      bindEvents();

      if (hasOptisConfig()) {
        sectionEl.classList.add('pcs--loading');
        waitForOptis(function() {
          initOptisDefaults();
          updatePrice();
          buildReview();
        });
      } else {
        initOptisDefaults();
      }
    }

    function initDefaults() {
      for (var i = 0; i < totalSteps; i++) {
        var step = steps[i];
        if (step.type === 'Slider') {
          selections[step.name] = step['default'] || step.min || 0;
        } else if (step.type === 'Checkbox') {
          selections[step.name] = 'No';
        } else if (step.type === 'Select' && step.optionList && step.optionList.length > 0) {
          selections[step.name] = step.optionList[0].value || step.optionList[0].name;
        } else if (step.type === 'Color' && step.colorOptions) {
          var stdColors = step.colorOptions.standard || [];
          if (stdColors.length > 0) selections[step.name] = stdColors[0];
        } else if (step.type === 'Fabric' && step.fabricOptionList && step.fabricOptionList.length > 0) {
          selections[step.name] = step.fabricOptionList[0].value || step.fabricOptionList[0].name || step.fabricOptionList[0].label;
        } else if (step.type === 'Select With Image' && step.imageOptions && step.imageOptions.length > 0) {
          selections[step.name] = step.imageOptions[0].value || step.imageOptions[0].name;
        }
      }
    }

    function applyDefaultSelectionsUI() {
      for (var i = 0; i < totalSteps; i++) {
        var step = steps[i];
        var stepEl = sectionEl.querySelector('[data-pcs-step="' + i + '"]');
        if (!stepEl) continue;
        var val = selections[step.name];
        if (val === undefined || val === null) continue;

        if (step.type === 'Select') {
          var selectBtns = stepEl.querySelectorAll('[data-select-value]');
          selectBtns.forEach(function (btn) {
            if (btn.getAttribute('data-select-value') === val) {
              btn.classList.add('pcs__select-btn--selected');
            }
          });
        } else if (step.type === 'Color') {
          var colorBtns = stepEl.querySelectorAll('[data-color-value]');
          colorBtns.forEach(function (btn) {
            if (btn.getAttribute('data-color-value') === val) {
              btn.classList.add('pcs__color-btn--selected');
            }
          });
        } else if (step.type === 'Fabric') {
          var fabricBtns = stepEl.querySelectorAll('[data-fabric-value]');
          fabricBtns.forEach(function (btn) {
            if (btn.getAttribute('data-fabric-value') === val) {
              btn.classList.add('pcs__fabric-btn--selected');
            }
          });
        } else if (step.type === 'Select With Image') {
          var imgSelBtns = stepEl.querySelectorAll('[data-imgselect-value]');
          imgSelBtns.forEach(function (btn) {
            if (btn.getAttribute('data-imgselect-value') === val) {
              btn.classList.add('pcs__imgselect-btn--selected');
            }
          });
        }
      }
    }

    var ralMap = {
      '1000': '#BEBD7F', '1001': '#C2B078', '1002': '#C6A664', '1003': '#E5BE01', '1004': '#CDA434',
      '1005': '#A98307', '1006': '#E4A010', '1007': '#DC9D00', '1011': '#8A6642', '1012': '#C7B446',
      '1013': '#EAE6CA', '1014': '#E1CC4F', '1015': '#E6D690', '1016': '#EDFF21', '1017': '#F5D033',
      '1018': '#F8F32B', '1019': '#9E9764', '1020': '#999950', '1021': '#F3DA0B', '1023': '#FAD201',
      '1024': '#AEA04B', '1026': '#FFFF00', '1027': '#9D9101', '1028': '#F4A900', '1032': '#D6AE01',
      '1033': '#F3A505', '1034': '#EFA94A', '1035': '#6A5D4D', '1036': '#705335', '1037': '#F39F18',
      '2000': '#ED760E', '2001': '#C93C20', '2002': '#CB2821', '2003': '#FF7514', '2004': '#F44611',
      '2005': '#FF2301', '2007': '#FFB300', '2008': '#F35B20', '2009': '#F54021', '2010': '#D84B20',
      '2011': '#EC7C26', '2012': '#E55137', '2013': '#C35831', '3000': '#AF2B1E', '3001': '#A52019',
      '3002': '#A2231D', '3003': '#9B111E', '3004': '#75151E', '3005': '#5E2129', '3007': '#412227',
      '3009': '#642424', '3011': '#781F19', '3012': '#C1876B', '3013': '#A12312', '3014': '#D36E70',
      '3015': '#EA899A', '3016': '#B32821', '3017': '#E63244', '3018': '#D53032', '3020': '#CC0605',
      '3022': '#D95030', '3024': '#F80000', '3026': '#FE0000', '3027': '#C51D34', '3028': '#CC0605',
      '3031': '#B32428', '3032': '#721422', '3033': '#B44C43', '4001': '#6D3F5B', '4002': '#922B3E',
      '4003': '#DE4C8A', '4004': '#641C34', '4005': '#6C4675', '4006': '#A03472', '4007': '#4A192C',
      '4008': '#924E7D', '4009': '#A18594', '4010': '#CF3476', '4011': '#8673A1', '4012': '#6C6874',
      '5000': '#354D73', '5001': '#1F3438', '5002': '#20214F', '5003': '#1D1E33', '5004': '#18171C',
      '5005': '#1E2460', '5007': '#3E5F8A', '5008': '#26252D', '5009': '#025669', '5010': '#0E294B',
      '5011': '#231A24', '5012': '#3B83BD', '5013': '#1E213D', '5014': '#606E8C', '5015': '#2271B3',
      '5017': '#063971', '5018': '#3F888F', '5019': '#1B5583', '5020': '#1D334A', '5021': '#256D7B',
      '5022': '#252850', '5023': '#49678D', '5024': '#5D9B9B', '5025': '#2A6478', '5026': '#102C54',
      '6000': '#316650', '6001': '#287233', '6002': '#2D572C', '6003': '#424632', '6004': '#1F3A3D',
      '6005': '#2F4538', '6006': '#3E3B32', '6007': '#343B29', '6008': '#39352A', '6009': '#31372B',
      '6010': '#35682D', '6011': '#587246', '6012': '#343E40', '6013': '#6C7156', '6014': '#47402E',
      '6015': '#3B3C36', '6016': '#1E5945', '6017': '#4C9141', '6018': '#57A639', '6019': '#BDECB6',
      '6020': '#2E3A23', '6021': '#89AC76', '6022': '#25221B', '6024': '#308446', '6025': '#3D642D',
      '6026': '#015D52', '6027': '#84C3BE', '6028': '#2C5545', '6029': '#20603D', '6032': '#317F43',
      '6033': '#497E76', '6034': '#7FB5B5', '6035': '#1C542D', '6036': '#193737', '6037': '#008F39',
      '6038': '#00BB2D', '7000': '#78858B', '7001': '#8A9597', '7002': '#7E7B52', '7003': '#6C7059',
      '7004': '#969992', '7005': '#646B63', '7006': '#6D6552', '7008': '#6A5F31', '7009': '#4D5645',
      '7010': '#4C514A', '7011': '#434B4D', '7012': '#4E5754', '7013': '#464531', '7015': '#434750',
      '7016': '#293133', '7021': '#23282B', '7022': '#332F2C', '7023': '#686C5E', '7024': '#474A51',
      '7026': '#2F353B', '7030': '#8B8C7A', '7031': '#474B4E', '7032': '#B8B799', '7033': '#7D8471',
      '7034': '#8F8B66', '7035': '#D7D7D7', '7036': '#7F7679', '7037': '#7D7F7D', '7038': '#B5B8B1',
      '7039': '#6C6960', '7040': '#9DA1AA', '7042': '#8D948D', '7043': '#4E5452', '7044': '#CAC4B0',
      '7045': '#909090', '7046': '#82898F', '7047': '#D0D0D0', '7048': '#898176', '8000': '#826C34',
      '8001': '#955F20', '8002': '#6C3B2A', '8003': '#734222', '8004': '#8E402A', '8007': '#59351F',
      '8008': '#6F4F28', '8011': '#5B3A29', '8012': '#592321', '8014': '#382C1E', '8015': '#633A34',
      '8016': '#4C2F27', '8017': '#45322E', '8019': '#403A3A', '8022': '#212121', '8023': '#A65E2E',
      '8024': '#79553D', '8025': '#755C48', '8028': '#4E3B31', '8029': '#763C28', '9001': '#FDF4E3',
      '9002': '#E7EBDA', '9003': '#F4F4F4', '9004': '#282828', '9005': '#0A0A0D', '9006': '#A5A5A5',
      '9007': '#8F8F8F', '9010': '#F5F5F5', '9011': '#1C1C1C', '9016': '#F7F7F7', '9017': '#1E1E1E',
      '9018': '#D7D7D7', '9022': '#9C9C9C', '9023': '#828282'
    };

    function ralToHex(ralStr) {
      var num = ralStr.replace(/[^0-9]/g, '').trim();
      return ralMap[num] || null;
    }

    function ralNumber(valStr) {
      var num = valStr.replace(/[^0-9]/g, '').trim();
      return num.length > 0 ? parseInt(num, 10) : Infinity;
    }

    function sortColorGrid(grid) {
      var btns = Array.prototype.slice.call(grid.querySelectorAll('.pcs__color-btn'));
      if (btns.length < 2) return;

      var hasRal = false;
      btns.forEach(function (btn) {
        var val = (btn.getAttribute('data-color-value') || '').toLowerCase().trim();
        if (val.indexOf('ral') === 0) hasRal = true;
      });
      if (!hasRal) return;

      btns.sort(function (a, b) {
        var aVal = (a.getAttribute('data-color-value') || '').toLowerCase().trim();
        var bVal = (b.getAttribute('data-color-value') || '').toLowerCase().trim();
        var aIsRal = aVal.indexOf('ral') === 0;
        var bIsRal = bVal.indexOf('ral') === 0;
        if (!aIsRal && !bIsRal) return 0;
        if (!aIsRal) return 1;
        if (!bIsRal) return -1;
        return ralNumber(aVal) - ralNumber(bVal);
      });

      btns.forEach(function (btn) { grid.appendChild(btn); });
    }

    function initColorSwatches() {
      var swatches = sectionEl.querySelectorAll('[data-color-bg]');
      swatches.forEach(function (el) {
        var val = el.getAttribute('data-color-bg');
        if (!val) return;
        var lower = val.toLowerCase().trim();
        if (lower.charAt(0) === '#' || lower.indexOf('rgb') === 0 || isNamedColor(lower)) {
          el.style.backgroundColor = val;
        } else if (lower.indexOf('ral') === 0) {
          var hex = ralToHex(lower);
          el.classList.add('pcs__color-circle--ral');
          if (hex) {
            el.style.backgroundColor = hex;
            el.setAttribute('title', val);
          } else {
            el.style.backgroundColor = '#888';
          }
          el.textContent = val;
        } else {
          el.style.backgroundColor = val;
        }
      });

      sectionEl.querySelectorAll('.pcs__colors-grid').forEach(sortColorGrid);
    }

    function isNamedColor(str) {
      var named = ['white', 'black', 'red', 'blue', 'green', 'gray', 'grey', 'silver', 'brown', 'beige', 'ivory',
        'orange', 'yellow', 'purple', 'pink', 'navy', 'teal', 'olive', 'maroon', 'aqua', 'coral', 'gold',
        'tan', 'wheat', 'salmon', 'lime', 'cyan', 'crimson', 'indigo', 'violet', 'khaki', 'magenta'];
      return named.indexOf(str) > -1;
    }

    function initAppLinkQR() {
      if (typeof qrcode !== 'function') return;
      var appLinkEls = sectionEl.querySelectorAll('[data-pcs-applink]');
      appLinkEls.forEach(function (el) {
        var url = el.getAttribute('data-pcs-applink');
        if (!url) return;
        var qrContainer = el.querySelector('[data-pcs-applink-qr]');
        if (!qrContainer) return;
        var qr = qrcode(0, 'L');
        qr.addData(url);
        qr.make();
        var count = qr.getModuleCount();
        var border = 2;
        var full = count + border * 2;
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + full + ' ' + full + '" shape-rendering="crispEdges">';
        svg += '<rect width="' + full + '" height="' + full + '" fill="#fff"/>';
        for (var r = 0; r < count; r++) {
          for (var c = 0; c < count; c++) {
            if (qr.isDark(r, c)) {
              svg += '<rect x="' + (c + border) + '" y="' + (r + border) + '" width="1" height="1" fill="#2B2A29"/>';
            }
          }
        }
        svg += '</svg>';
        qrContainer.innerHTML = svg;
      });
    }

    /* ── Condition Evaluation ── */
    var conditionMessages = {};

    function parseExpr(str) {
      if (!str) return null;
      var ops = ['<=', '>=', '>', '<', '='];
      for (var i = 0; i < ops.length; i++) {
        var op = ops[i];
        var idx = str.lastIndexOf(op);
        if (idx <= 0) continue;
        if ((op === '>' || op === '<') && idx + 1 < str.length && str.charAt(idx + 1) === '=') continue;
        if (op === '=' && idx > 0 && (str.charAt(idx - 1) === '<' || str.charAt(idx - 1) === '>')) continue;
        return { left: str.substring(0, idx).trim(), op: op, right: str.substring(idx + op.length).trim() };
      }
      return null;
    }

    function parseTarget(str) {
      var ops = ['<=', '>=', '>', '<'];
      for (var i = 0; i < ops.length; i++) {
        if (str.indexOf(ops[i]) === 0) {
          return { type: 'range', op: ops[i], val: parseFloat(str.substring(ops[i].length).trim()) };
        }
      }
      return { type: 'option', name: str };
    }

    function getOptionNameForValue(stepName, val) {
      for (var s = 0; s < steps.length; s++) {
        if (steps[s].name !== stepName) continue;
        var st = steps[s];
        if (st.type === 'Select' && st.optionList) {
          for (var j = 0; j < st.optionList.length; j++) {
            if ((st.optionList[j].value || st.optionList[j].name) === val) return st.optionList[j].name;
          }
        } else if (st.type === 'Fabric' && st.fabricOptionList) {
          for (var j = 0; j < st.fabricOptionList.length; j++) {
            var f = st.fabricOptionList[j];
            if ((f.value || f.name || f.label) === val) return f.name || f.label;
          }
        } else if (st.type === 'Select With Image' && st.imageOptions) {
          for (var j = 0; j < st.imageOptions.length; j++) {
            if ((st.imageOptions[j].value || st.imageOptions[j].name) === val) return st.imageOptions[j].name;
          }
        }
        break;
      }
      return val;
    }

    function evalExpr(expr) {
      var actual = selections[expr.left];
      if (actual === undefined || actual === null) return false;
      var numA = parseFloat(actual);
      var numB = parseFloat(expr.right);
      var isNum = !isNaN(numA) && !isNaN(numB);
      switch (expr.op) {
        case '=':
          if (isNum) return numA === numB;
          if (String(actual) === expr.right) return true;
          var nameForVal = getOptionNameForValue(expr.left, actual);
          return nameForVal !== actual && String(nameForVal) === expr.right;
        case '>': return isNum && numA > numB;
        case '<': return isNum && numA < numB;
        case '>=': return isNum && numA >= numB;
        case '<=': return isNum && numA <= numB;
      }
      return false;
    }

    function opSymbol(op) {
      switch (op) {
        case '=': return '='; case '>': return '>'; case '<': return '<';
        case '>=': return '\u2265'; case '<=': return '\u2264';
      }
      return op;
    }

    function parseCondition(func, when) {
      if (func === 'That specific min width') {
        return { type: 'minWidth', sourceStep: 'Projection', offset: 500 };
      }
      if (!when) return null;
      var pipeIdx = when.indexOf('|');
      if (pipeIdx === -1) {
        var expr = parseExpr(when);
        if (!expr) return null;
        return { type: func.toLowerCase() === 'able' ? 'able' : 'disable', target: { type: 'step' }, cond: expr };
      }
      var targetStr = when.substring(0, pipeIdx).trim();
      var condStr = when.substring(pipeIdx + 1).trim();
      var target = parseTarget(targetStr);
      var cond = parseExpr(condStr);
      if (!cond) return null;
      return { type: func.toLowerCase() === 'able' ? 'able' : 'disable', target: target, cond: cond };
    }

    function applySliderBounds(stepIdx, newMin, newMax) {
      var s = steps[stepIdx];
      if (!s || s.type !== 'Slider') return;
      var el = sectionEl.querySelector('[data-pcs-step="' + stepIdx + '"]');
      if (!el) return;
      var rng = el.querySelector('[data-slider-range]');
      var num = el.querySelector('[data-slider-number]');
      var minLbl = el.querySelector('[data-slider-min-label]');
      var maxLbl = el.querySelector('[data-slider-max-label]');
      var display = el.querySelector('[data-slider-display]');

      if (newMin !== null) {
        s.min = newMin;
        if (rng) rng.min = newMin;
        if (minLbl) minLbl.textContent = newMin;
      }
      if (newMax !== null) {
        s.max = newMax;
        if (rng) rng.max = newMax;
        if (maxLbl) maxLbl.textContent = newMax;
      }

      var cur = parseInt(rng ? rng.value : 0);
      var clamped = Math.max(s.min, Math.min(s.max, cur));
      if (clamped !== cur) {
        if (rng) rng.value = clamped;
        if (num) num.value = clamped;
        if (display) display.textContent = clamped;
        selections[s.name] = clamped;
      }
      if (rng) updateSliderFill(rng);
    }

    function resetSliderBounds(stepIdx) {
      var s = steps[stepIdx];
      if (!s || s.type !== 'Slider') return;
      var el = sectionEl.querySelector('[data-pcs-step="' + stepIdx + '"]');
      if (!el) return;
      var rng = el.querySelector('[data-slider-range]');
      var origMin = rng ? parseInt(rng.getAttribute('data-original-min')) : s.min;
      var origMax = rng ? parseInt(rng.getAttribute('data-original-max')) : s.max;
      applySliderBounds(stepIdx, origMin, origMax);
    }

    function buildCondMsg(p, step, isAble) {
      var label = isAble ? t.cond_requires : t.cond_unavailable;
      var stepDisplay = step.displayName || step.name;
      if (p.target.type === 'step') return '"' + stepDisplay + '" ' + label + ' "' + p.cond.left + '" ' + opSymbol(p.cond.op) + ' "' + p.cond.right + '"';
      if (p.target.type === 'option') return '"' + p.target.name + '" ' + label + ' "' + p.cond.left + '" ' + opSymbol(p.cond.op) + ' "' + p.cond.right + '"';
      return null;
    }

    function targetKey(p) {
      if (p.target.type === 'step') return '_step_';
      if (p.target.type === 'option') return 'o:' + p.target.name;
      return 'r:' + p.target.op + p.target.val;
    }

    function evaluateAllConditions() {
      disabledOptions = {};
      conditionMessages = {};

      for (var i = 0; i < totalSteps; i++) {
        stepEnabled[i] = true;
      }

      for (var i = 0; i < totalSteps; i++) {
        var step = steps[i];
        var conds = step.conditions;
        if (!conds || conds.length === 0) continue;

        var msgs = [];
        var groups = {};
        var hasRange = false;
        var sliderMinAdj = null;
        var sliderMaxAdj = null;

        for (var c = 0; c < conds.length; c++) {
          var p = parseCondition(conds[c].func, conds[c].when);
          if (!p) continue;

          if (p.type === 'minWidth') {
            hasRange = true;
            var projVal = selections[p.sourceStep];
            if (projVal !== undefined && projVal !== null && !isNaN(parseInt(projVal))) {
              var nMin = parseInt(projVal) + p.offset;
              sliderMinAdj = sliderMinAdj !== null ? Math.max(sliderMinAdj, nMin) : nMin;
              msgs.push(t.condition_min_width.replace('__VALUE__', nMin));
            }
            continue;
          }

          var met = evalExpr(p.cond);
          var key = targetKey(p);
          if (!groups[key]) groups[key] = [];
          groups[key].push({ p: p, met: met });
        }

        for (var key in groups) {
          var grp = groups[key];

          // Sub-group by cond.left (the step name being checked).
          // Within a sub-group: AND (all conditions on the same step must be met).
          // Across sub-groups: OR (any sub-group firing is enough to trigger).
          var subGroups = {};
          for (var g = 0; g < grp.length; g++) {
            var ck = grp[g].p.cond.left;
            if (!subGroups[ck]) subGroups[ck] = [];
            subGroups[ck].push(grp[g]);
          }

          var anyAbleMet = false, hasAble = false;
          var anyDisableMet = false, hasDisable = false;
          var trigP = null;

          for (var ck in subGroups) {
            var sub = subGroups[ck];
            var subAllMet = true;
            var subHasAble = false, subHasDisable = false;
            var subTrigP = null;
            for (var g = 0; g < sub.length; g++) {
              var item = sub[g];
              if (item.p.type === 'able') {
                subHasAble = true;
                if (!item.met) { subAllMet = false; if (!subTrigP) subTrigP = item.p; }
              } else {
                subHasDisable = true;
                if (!item.met) subAllMet = false;
                if (item.met && !subTrigP) subTrigP = item.p;
              }
            }
            if (subHasAble) {
              hasAble = true;
              if (subAllMet) anyAbleMet = true;
              else if (!trigP) trigP = subTrigP;
            }
            if (subHasDisable) {
              hasDisable = true;
              if (subAllMet) { anyDisableMet = true; if (!trigP) trigP = subTrigP; }
            }
          }

          var restrict = false;
          var isAble = false;
          if (hasAble && !anyAbleMet) { restrict = true; isAble = true; }
          if (hasDisable && anyDisableMet) { restrict = true; isAble = false; }
          if (hasAble && anyAbleMet && hasDisable && anyDisableMet) { restrict = true; isAble = false; }

          var firstP = grp[0].p;

          if (firstP.target.type === 'range') {
            hasRange = true;
            if (restrict && trigP) {
              var tOp = firstP.target.op;
              var tVal = firstP.target.val;
              if (tOp === '>' || tOp === '>=') {
                var newMax = (tOp === '>') ? tVal : tVal - step.increment;
                sliderMaxAdj = sliderMaxAdj !== null ? Math.min(sliderMaxAdj, newMax) : newMax;
                msgs.push(t.cond_max_adj.replace('__VALUE__', newMax) + ' ("' + trigP.cond.left + '" ' + opSymbol(trigP.cond.op) + ' ' + trigP.cond.right + ')');
              } else if (tOp === '<' || tOp === '<=') {
                var newMin = (tOp === '<') ? tVal : tVal + step.increment;
                sliderMinAdj = sliderMinAdj !== null ? Math.max(sliderMinAdj, newMin) : newMin;
                msgs.push(t.cond_min_adj.replace('__VALUE__', newMin) + ' ("' + trigP.cond.left + '" ' + opSymbol(trigP.cond.op) + ' ' + trigP.cond.right + ')');
              }
            }
          } else if (restrict && trigP) {
            if (firstP.target.type === 'step') {
              stepEnabled[i] = false;
              msgs.push(buildCondMsg(trigP, step, isAble));
            } else if (firstP.target.type === 'option') {
              disabledOptions[step.name + '/' + firstP.target.name] = true;
              msgs.push(buildCondMsg(trigP, step, isAble));
            }
          }
        }

        if (hasRange) {
          var rng = sectionEl.querySelector('[data-pcs-step="' + i + '"] [data-slider-range]');
          var oMin = rng ? parseInt(rng.getAttribute('data-original-min')) : step.min;
          var oMax = rng ? parseInt(rng.getAttribute('data-original-max')) : step.max;
          applySliderBounds(i, sliderMinAdj !== null ? sliderMinAdj : oMin, sliderMaxAdj !== null ? sliderMaxAdj : oMax);
        }

        if (msgs.length > 0) conditionMessages[i] = msgs.join('<br>');
      }

      updateDisabledOptionsUI();
      updateConditionNotices();
      updateProgressBar();
    }

    function updateDisabledOptionsUI() {
      for (var i = 0; i < totalSteps; i++) {
        var step = steps[i];
        if (step.type !== 'Select') continue;
        var stepEl = sectionEl.querySelector('[data-pcs-step="' + i + '"]');
        if (!stepEl) continue;

        var btns = stepEl.querySelectorAll('[data-select-value]');
        var selectionCleared = false;
        btns.forEach(function (btn) {
          var optVal = btn.getAttribute('data-select-value');
          var key = step.name + '/' + optVal;
          if (disabledOptions[key]) {
            btn.hidden = true;
            btn.disabled = true;
            if (selections[step.name] === optVal) {
              delete selections[step.name];
              btn.classList.remove('pcs__select-btn--selected');
              selectionCleared = true;
            }
          } else {
            btn.hidden = false;
            btn.disabled = false;
          }
        });

        if (selectionCleared) {
          btns.forEach(function (btn) {
            var optVal = btn.getAttribute('data-select-value');
            var key = step.name + '/' + optVal;
            if (!disabledOptions[key] && !selections[step.name]) {
              selections[step.name] = optVal;
              btn.classList.add('pcs__select-btn--selected');
            }
          });
        }
      }
    }

    function updateConditionNotices() {
      for (var i = 0; i < totalSteps; i++) {
        var step = steps[i];
        if (!step.conditions || step.conditions.length === 0) continue;
        var stepEl = sectionEl.querySelector('[data-pcs-step="' + i + '"]');
        if (!stepEl) continue;
        var notice = stepEl.querySelector('[data-pcs-condition-notice]');
        if (!notice) continue;
        var textEl = notice.querySelector('[data-pcs-condition-text]');

        notice.hidden = true;
      }
    }

    /* ── Navigation ── */
    function getNextEnabled(from) {
      for (var i = from + 1; i < totalSteps; i++) {
        if (stepEnabled[i]) return i;
      }
      return -1;
    }

    function getPrevEnabled(from) {
      for (var i = from - 1; i >= 0; i--) {
        if (stepEnabled[i]) return i;
      }
      return -1;
    }

    function scrollSectionToTop() {
      if (sectionEl) {
        sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function goToStep(idx) {
      onSummary = false;
      currentStepIdx = idx;
      updateUI();
      scrollSectionToTop();
    }

    function goToSummary() {
      onSummary = true;
      updateUI();
      scrollSectionToTop();
    }

    function nextStep() {
      if (onSummary) return;
      var next = getNextEnabled(currentStepIdx);
      if (next >= 0) {
        goToStep(next);
      } else {
        buildReview();
        goToSummary();
      }
    }

    function prevStep() {
      if (onSummary) {
        var lastEnabled = -1;
        for (var i = totalSteps - 1; i >= 0; i--) {
          if (stepEnabled[i]) { lastEnabled = i; break; }
        }
        if (lastEnabled >= 0) {
          goToStep(lastEnabled);
        }
        return;
      }
      var prev = getPrevEnabled(currentStepIdx);
      if (prev >= 0) {
        goToStep(prev);
      }
    }

    /* ── UI Update ── */
    function updateProgressBar() {
      var lastVisibleIdx = -1;
      for (var i = totalSteps - 1; i >= 0; i--) {
        if (stepEnabled[i]) { lastVisibleIdx = i; break; }
      }

      progressItems.forEach(function (item) {
        var idx = parseInt(item.getAttribute('data-pcs-progress-item'));
        item.classList.toggle('pcs__progress-item--hidden', !stepEnabled[idx]);
        item.classList.toggle('pcs__progress-item--last-visible', idx === lastVisibleIdx);
      });

      progressDots.forEach(function (dot) {
        var idx = parseInt(dot.getAttribute('data-pcs-progress-dot'));
        dot.classList.remove('pcs__progress-dot--active', 'pcs__progress-dot--done', 'pcs__progress-dot--disabled');
        if (!stepEnabled[idx]) {
          dot.classList.add('pcs__progress-dot--disabled');
        } else if (onSummary || idx < currentStepIdx) {
          dot.classList.add('pcs__progress-dot--done');
        } else if (idx === currentStepIdx && !onSummary) {
          dot.classList.add('pcs__progress-dot--active');
        }
      });

      lineFills.forEach(function (line) {
        var idx = parseInt(line.getAttribute('data-pcs-line-fill'));
        if (onSummary || idx < currentStepIdx) {
          line.style.width = '100%';
        } else {
          line.style.width = '0%';
        }
      });
    }

    function updateUI() {
      stepEls.forEach(function (el) {
        var idx = el.getAttribute('data-pcs-step');
        if (onSummary) {
          el.classList.toggle('pcs__step--active', idx === 'summary');
        } else {
          el.classList.toggle('pcs__step--active', idx === String(currentStepIdx));
        }
      });

      var activeStep = onSummary
        ? sectionEl.querySelector('[data-pcs-step="summary"]')
        : sectionEl.querySelector('[data-pcs-step="' + currentStepIdx + '"]');
      if (activeStep && controlsEl) {
        var head = activeStep.querySelector('.pcs__step-head');
        if (head) {
          head.appendChild(controlsEl);
        } else {
          activeStep.insertBefore(controlsEl, activeStep.firstChild);
        }
      }

      updateProgressBar();

      if (onSummary) {
        backBtn.disabled = false;
        navWrap.hidden = true;
        cartWrap.hidden = false;
      } else {
        navWrap.hidden = false;
        cartWrap.hidden = true;
        backBtn.disabled = getPrevEnabled(currentStepIdx) < 0;
        var hasNext = getNextEnabled(currentStepIdx);
        nextBtn.textContent = '';
        if (hasNext >= 0) {
          nextBtn.innerHTML = t['continue'] + ' <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M7 4l5 5-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        } else {
          nextBtn.innerHTML = t.review_add + ' <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M7 4l5 5-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        }
      }

      updatePrice();
    }

    /* ── Variant Matching ── */
    function getOptionValues(optionIdx) {
      var vals = {};
      config.variants.forEach(function (v) {
        if (v.options && v.options[optionIdx]) {
          vals[v.options[optionIdx]] = true;
        }
      });
      return Object.keys(vals);
    }

    function findNearestHigh(selectedVal, optionValues) {
      var numVal = parseFloat(selectedVal);
      var numericVals = optionValues
        .map(function (v) { return { str: v, num: parseFloat(v) }; })
        .filter(function (v) { return !isNaN(v.num); })
        .sort(function (a, b) { return a.num - b.num; });

      if (numericVals.length === 0) return null;

      for (var i = 0; i < numericVals.length; i++) {
        if (numericVals[i].num >= numVal) return numericVals[i].str;
      }
      return numericVals[numericVals.length - 1].str;
    }

    function findStepByVariantOption(varOptName) {
      for (var si = 0; si < steps.length; si++) {
        if (steps[si].key === varOptName || steps[si].key === varOptName) return steps[si];
      }
      return null;
    }

    function parseFabricLevel(val) {
      if (!val || typeof val !== 'string') return null;
      var idx = val.lastIndexOf('__');
      if (idx < 1) return null;
      var level = val.substring(idx + 2);
      var realVal = val.substring(0, idx);
      return { realValue: realVal, level: level };
    }

    function stripFabricLevel(val) {
      var parsed = parseFabricLevel(val);
      return parsed ? parsed.realValue : val;
    }

    function findMatchingVariant() {
      var optionNames = config.optionNames;
      var matchedOpts = {};

      for (var oi = 0; oi < optionNames.length; oi++) {
        var step = findStepByVariantOption(optionNames[oi]);
        if (!step) continue;
        if (!stepEnabled[step.index]) continue;

        if (step.type === 'Slider' && step.getNeastVariant) {
          var selVal = selections[step.name];
          if (selVal === undefined) continue;
          var optVals = getOptionValues(oi);
          var nearest = findNearestHigh(selVal, optVals);
          if (nearest) matchedOpts[oi] = nearest;
        }
      }

      for (var si2 = 0; si2 < steps.length; si2++) {
        var selStep = steps[si2];
        var isSelect = selStep.type === 'Select' && selStep.optionList;
        var isImgSelect = selStep.type === 'Select With Image' && selStep.imageOptions;
        if (!isSelect && !isImgSelect) continue;
        if (!stepEnabled[selStep.index]) continue;

        var selVal = selections[selStep.name];
        if (!selVal) continue;

        var optArr = isImgSelect ? selStep.imageOptions : selStep.optionList;
        for (var j = 0; j < optArr.length; j++) {
          var opt = optArr[j];
          var optValue = opt.value || opt.name;
          if (optValue !== selVal || !opt.variantLabel) continue;

          var optName = opt.value || opt.name;
          var vl = opt.variantLabel;
          var slashIdx = vl.indexOf('/');
          if (slashIdx > -1) {
            var vlOptName = vl.substring(0, slashIdx).trim();
            var vlOptVal = vl.substring(slashIdx + 1).trim();
            for (var oi2 = 0; oi2 < optionNames.length; oi2++) {
              if (optionNames[oi2] === vlOptName) {
                matchedOpts[oi2] = vlOptVal;
                break;
              }
            }
          } else {
            for (var oi3 = 0; oi3 < optionNames.length; oi3++) {
              if (optionNames[oi3] === vl) {
                matchedOpts[oi3] = optName;
                break;
              }
            }
          }
          break;
        }
      }

      for (var fi = 0; fi < steps.length; fi++) {
        var fabStep = steps[fi];
        if (fabStep.type !== 'Fabric' || !fabStep.fabricOptionList) continue;
        if (!stepEnabled[fabStep.index]) continue;
        var fabVal = selections[fabStep.name];
        if (!fabVal) continue;
        var parsed = parseFabricLevel(String(fabVal));
        if (!parsed) continue;
        var fabricOptIdx = -1;
        for (var foi = 0; foi < optionNames.length; foi++) {
          var on = optionNames[foi];
          if (on === 'Fabric' || on === fabStep.name || on === fabStep.key) {
            fabricOptIdx = foi;
            break;
          }
        }
        if (fabricOptIdx === -1) {
          for (var foi2 = 0; foi2 < optionNames.length; foi2++) {
            var vals = getOptionValues(foi2);
            if (vals.indexOf(parsed.level) > -1) {
              fabricOptIdx = foi2;
              break;
            }
          }
        }
        if (fabricOptIdx > -1) {
          matchedOpts[fabricOptIdx] = parsed.level;
        }
      }

      var matchKeys = Object.keys(matchedOpts);
      if (matchKeys.length === 0) return config.variants[0] || null;

      for (var vi = 0; vi < config.variants.length; vi++) {
        var variant = config.variants[vi];
        if (!variant.options) continue;
        var allMatch = true;
        for (var k = 0; k < matchKeys.length; k++) {
          var optIdx = parseInt(matchKeys[k]);
          if (variant.options[optIdx] !== matchedOpts[optIdx]) {
            allMatch = false;
            break;
          }
        }
        if (allMatch) return variant;
      }

      return null;
    }

    /* ── OPTIS Product Options integration ── */

    var optisActiveInputs = {}; // stepName → currently-active inputId

    function parseOptisExtraPrice(text) {
      if (!text) return 0;
      var match = text.match(/[\d.,]+/);
      if (!match) return 0;
      var numStr = match[0].replace(/\./g, '').replace(',', '.');
      var amount = parseFloat(numStr);
      return isNaN(amount) ? 0 : Math.round(amount * 100);
    }

    function getOptisPriceElement(el) {
      var found = el.closest('.po-extra-price');
      if (found) return found;
      if (el.parentElement) {
        found = el.parentElement.querySelector('.po-extra-price');
        if (found) return found;
      }
      if (el.parentElement && el.parentElement.parentElement) {
        found = el.parentElement.parentElement.querySelector('.po-extra-price');
        if (found) return found;
      }
      return null;
    }

    function resolveOptisInput(selector) {
      var el = document.querySelector(selector);
      if (!el) return null;
      // If the matched element is a wrapper, find the real input inside
      if (el.tagName !== 'INPUT') {
        var inner = el.querySelector('input');
        if (inner) return inner;
      }
      return el;
    }

    function readOptisPrice(selector) {
      var el = document.querySelector(selector);
      if (!el) return 0;
      var input = resolveOptisInput(selector);
      var priceEl = getOptisPriceElement(input || el);
      if (!priceEl && input && input !== el) priceEl = getOptisPriceElement(el);
      return priceEl ? parseOptisExtraPrice(priceEl.textContent) : 0;
    }

    function activateOptisInput(inputId, setValue) {
      var input = resolveOptisInput(inputId);
      if (!input) return;
      if (input.type === 'checkbox' || input.type === 'radio') {
        // Set checked directly — never toggle
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        if (setValue !== undefined && setValue !== null) input.value = setValue;
        input.click();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function deactivateOptisInput(inputId) {
      var input = resolveOptisInput(inputId);
      if (!input) return;
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function setOptisPrice(stepName, inputId, setValue) {
      var prev = optisActiveInputs[stepName];
      if (prev && prev !== inputId) deactivateOptisInput(prev);
      optisActiveInputs[stepName] = inputId;
      activateOptisInput(inputId, setValue);
      optisPrices[stepName] = readOptisPrice(inputId);
    }

    function clearOptisPrice(stepName) {
      var prev = optisActiveInputs[stepName];
      if (prev) deactivateOptisInput(prev);
      delete optisActiveInputs[stepName];
      optisPrices[stepName] = 0;
    }

    function getTotalOptisPrice() {
      var total = 0;
      for (var key in optisPrices) {
        if (optisPrices.hasOwnProperty(key)) total += optisPrices[key] || 0;
      }
      return total;
    }

    function initOptisDefaults() {
      for (var i = 0; i < totalSteps; i++) {
        var step = steps[i];
        if (!stepEnabled[i]) continue;
        var val = selections[step.name];
        if (val === undefined || val === null) continue;

        var optis = null;

        if (step.type === 'Select' && step.optionList) {
          for (var j = 0; j < step.optionList.length; j++) {
            if ((step.optionList[j].value || step.optionList[j].name) === val) {
              optis = step.optionList[j].optis || null;
              break;
            }
          }
        } else if (step.type === 'Fabric' && step.fabricOptionList) {
          for (var j = 0; j < step.fabricOptionList.length; j++) {
            var f = step.fabricOptionList[j];
            if ((f.value || f.name || f.label) === val) {
              optis = f.optis || null;
              break;
            }
          }
        } else if (step.type === 'Select With Image' && step.imageOptions) {
          for (var j = 0; j < step.imageOptions.length; j++) {
            if ((step.imageOptions[j].value || step.imageOptions[j].name) === val) {
              optis = step.imageOptions[j].optis || null;
              break;
            }
          }
        }

        if (optis) {
          setOptisPrice(step.name, optis);
        }
      }
    }

    /* ── Standard Variant Surcharge ── */
    function computeStandardSurcharge(selectedVariant) {
      var sv = config.standardVariant;
      if (!sv || !sv.name || !sv.value) return null;
      if (!selectedVariant || !selectedVariant.options) return null;

      var optionNames = config.optionNames;
      var svOptIdx = -1;
      for (var i = 0; i < optionNames.length; i++) {
        if (optionNames[i] === sv.name) { svOptIdx = i; break; }
      }
      if (svOptIdx === -1) return null;

      // Selected variant already uses the standard value — no surcharge
      if (selectedVariant.options[svOptIdx] === sv.value) return null;

      // Find the matching "standard" variant: identical options except sv.name = sv.value
      for (var vi = 0; vi < config.variants.length; vi++) {
        var v = config.variants[vi];
        if (!v.options) continue;
        if (v.options[svOptIdx] !== sv.value) continue;

        var allMatch = true;
        for (var oi = 0; oi < v.options.length; oi++) {
          if (oi === svOptIdx) continue;
          if (v.options[oi] !== selectedVariant.options[oi]) { allMatch = false; break; }
        }
        if (allMatch) {
          var surcharge = selectedVariant.price - v.price;
          if (surcharge <= 0) return null;
          return { basePrice: v.price, surcharge: surcharge };
        }
      }
      return null;
    }

    /* ── Price ── */
    function updatePrice() {
      var variant = findMatchingVariant();
      if (!variant) {
        if (variantErrorEl) {
          variantErrorEl.hidden = false;
          if (variantErrorText) variantErrorText.textContent = t.no_variant;
        }
        if (priceEl) priceEl.textContent = '—';
        if (addToCartBtn) addToCartBtn.disabled = true;
        return;
      }

      if (variantErrorEl) variantErrorEl.hidden = true;
      if (addToCartBtn) addToCartBtn.disabled = false;
      updateShadowFormVariant(variant.id);

      var standardSurcharge = computeStandardSurcharge(variant);
      var optisTotalCents = getTotalOptisPrice();
      var basePrice = standardSurcharge ? standardSurcharge.basePrice : variant.price;
      var totalSurcharge = (standardSurcharge ? standardSurcharge.surcharge : 0) + optisTotalCents;

      if (priceEl) {
        if (totalSurcharge > 0) {
          priceEl.innerHTML = formatMoney(basePrice) +
            ' <span class="pcs__price-surcharge">+ ' + formatMoney(totalSurcharge) + '</span>';
        } else {
          priceEl.textContent = formatMoney(variant.price);
        }
      }
      if (cartPriceEl) cartPriceEl.textContent = formatMoney(variant.price + optisTotalCents);

      if (priceCompareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompareEl.textContent = formatMoney(variant.compare_at_price);
          priceCompareEl.hidden = false;
        } else {
          priceCompareEl.hidden = true;
        }
      }

      updateGalleryForVariant(variant);
    }

    /* ── Review / Summary ── */
    function getOptionDisplayName(step, val) {
      if (step.type === 'Select' && step.optionList) {
        for (var j = 0; j < step.optionList.length; j++) {
          var o = step.optionList[j];
          if ((o.value || o.name) === val) return o.displayName || o.name;
        }
      } else if (step.type === 'Fabric' && step.fabricOptionList) {
        for (var j = 0; j < step.fabricOptionList.length; j++) {
          var f = step.fabricOptionList[j];
          if ((f.value || f.name || f.label) === val) return f.displayName || f.name || f.label;
        }
      } else if (step.type === 'Select With Image' && step.imageOptions) {
        for (var j = 0; j < step.imageOptions.length; j++) {
          var io = step.imageOptions[j];
          if ((io.value || io.name) === val) return io.displayName || io.name;
        }
      }
      return val;
    }

    function buildReview() {
      if (!reviewEl) return;
      var html = '<div class="pcs__review-list">';

      for (var i = 0; i < totalSteps; i++) {
        var step = steps[i];
        if (!stepEnabled[i]) continue;
        var val = selections[step.name];
        if (val === undefined || val === null || val === '') val = '—';

        var displayVal = val;
        if (step.type === 'Slider') {
          displayVal = val + ' ' + t.mm;
        } else if (step.type === 'Checkbox') {
          displayVal = val === 'Yes' ? t.yes : t.no;
        } else if (step.type === 'Fabric') {
          displayVal = stripFabricLevel(getOptionDisplayName(step, val));
        } else {
          displayVal = getOptionDisplayName(step, val);
        }

        var stepLabel = step.displayName || step.name;
        html += '<div class="pcs__review-item">';
        html += '<span class="pcs__review-label">' + escapeHtml(stepLabel) + '</span>';
        html += '<span class="pcs__review-value">' + escapeHtml(String(displayVal)) + '</span>';
        html += '</div>';
      }

      html += '</div>';

      var variant = findMatchingVariant();
      if (variant) {
        var reviewStandardSurcharge = computeStandardSurcharge(variant);
        var reviewOptisCents = getTotalOptisPrice();
        var reviewBasePrice = reviewStandardSurcharge ? reviewStandardSurcharge.basePrice : variant.price;
        var reviewTotalSurcharge = (reviewStandardSurcharge ? reviewStandardSurcharge.surcharge : 0) + reviewOptisCents;

        html += '<div class="pcs__review-price">';
        html += '<span>' + escapeHtml(t.total) + '</span>';
        if (reviewTotalSurcharge > 0) {
          html += '<span class="pcs__review-price-val">' +
            formatMoney(reviewBasePrice) +
            ' <span class="pcs__price-surcharge">+ ' + formatMoney(reviewTotalSurcharge) + '</span>' +
            '</span>';
        } else {
          html += '<span class="pcs__review-price-val">' + formatMoney(variant.price) + '</span>';
        }
        html += '</div>';
      }

      reviewEl.innerHTML = html;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    /* ── Cart ── */
    /* ── OPTIS: collect hidden form inputs from app blocks for cart payload ── */
    function updateShadowFormVariant(variantId) {
      var input = sectionEl.querySelector('[data-pcs-shadow-variant]');
      if (input && variantId) input.value = variantId;
    }

    function parseBssPriceKr(text) {
      if (!text) return 0;
      var match = text.match(/[\d.,]+/);
      if (!match) return 0;
      // Norwegian/European format: "7.000,00" → 7000
      var numStr = match[0].replace(/\./g, '').replace(',', '.');
      return parseFloat(numStr) || 0;
    }

    function collectBssPropertiesFromDom() {
      var customAttrs = {};
      var totalExtraKr = 0;

      // Find all active BSS option inputs by their "key" attribute (e.g. key="po_switch")
      var inputs = document.querySelectorAll('input[key^="po_"]');
      inputs.forEach(function (input) {
        // Only include active (checked/filled) inputs
        var isActive = (input.type === 'checkbox' || input.type === 'radio')
          ? input.checked
          : (input.value !== '' && input.value != null);
        if (!isActive) return;

        // labelOnProduct: strip "po_" prefix from the key attribute → "switch"
        var keyAttr = input.getAttribute('key') || '';
        var labelOnProduct = keyAttr.replace(/^po_/, '');
        if (!labelOnProduct) return;

        // Traverse UP from input.parentElement to find .po-extra-price.
        // Cannot use closest('[id^="po_"]') — the input itself shares the wrapper id,
        // so closest() stops at the input and querySelector finds nothing.
        var priceEl = null;
        var searchEl = input.parentElement;
        for (var depth = 0; depth < 7 && searchEl; depth++) {
          priceEl = searchEl.querySelector('.po-extra-price');
          if (priceEl) break;
          searchEl = searchEl.parentElement;
        }
        var priceText = priceEl ? priceEl.textContent.trim() : '';
        var extraKr = parseBssPriceKr(priceText);

        var propKey = ' ' + labelOnProduct;
        var propValue = input.value + (priceText ? ' ' + priceText : '');
        customAttrs[propKey] = propValue;
        totalExtraKr += extraKr;
      });

      if (!Object.keys(customAttrs).length) return {};

      customAttrs['__bss_po_addons'] = String(totalExtraKr);

      var result = {};
      for (var k in customAttrs) {
        if (customAttrs.hasOwnProperty(k)) result[k] = customAttrs[k];
      }
      result['_bssPrice'] = JSON.stringify({ extra: totalExtraKr });
      result['_bssVariants'] = '{}';
      result['_bssCustomAttributes'] = JSON.stringify(customAttrs);
      return result;
    }

    function collectOptisProperties() {
      var props = {};

      // Primary: reconstruct BSS properties directly from the BSS DOM elements
      var bssProps = collectBssPropertiesFromDom();
      for (var k in bssProps) {
        if (bssProps.hasOwnProperty(k)) props[k] = bssProps[k];
      }

      // Fallback: any properties[…] named inputs in the shadow form or app blocks container
      if (!Object.keys(props).length) {
        var skipNames = { id: 1, quantity: 1, form_type: 1, utf8: 1 };
        var sources = [
          sectionEl.querySelector('[data-pcs-shadow-form]'),
          sectionEl.querySelector('.pcs__app-blocks')
        ];
        sources.forEach(function (container) {
          if (!container) return;
          container.querySelectorAll('input[name], select[name], textarea[name]').forEach(function (field) {
            var name = field.name;
            if (!name || skipNames[name]) return;
            var match = name.match(/^properties\[(.+)\]$/);
            if (!match) return;
            var key = match[1];
            if (field.type === 'checkbox' || field.type === 'radio') {
              if (field.checked) props[key] = field.value || 'yes';
            } else if (field.value !== '') {
              props[key] = field.value;
            }
          });
        });
      }

      return props;
    }

    function addToCart() {
      var variant = findMatchingVariant();
      if (!variant) {
        alert(t.no_variant);
        return;
      }

      var properties = {};
      for (var i = 0; i < totalSteps; i++) {
        var step = steps[i];
        if (!stepEnabled[i]) continue;
        var val = selections[step.name];
        if (val !== undefined && val !== null && val !== '') {
          var cartVal = (step.type === 'Fabric') ? stripFabricLevel(String(val)) : String(val);
          properties[step.key || step.name] = cartVal;
        }
      }

      var optisProps = collectOptisProperties();
      for (var ok in optisProps) {
        if (optisProps.hasOwnProperty(ok)) properties[ok] = optisProps[ok];
      }

      var payload = {
        id: variant.id,
        quantity: 1,
        properties: properties
      };

      var cartBtnTotalPrice = variant.price + getTotalOptisPrice();
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('pcs__cart-btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status && data.status === 422) {
            alert(data.description || t.could_not_add);
          } else {
            addToCartBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5 10l3.5 3.5L15 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg> ' + escapeHtml(t.added);
            addToCartBtn.classList.add('pcs__cart-btn--success');

            setTimeout(function () {
              addToCartBtn.classList.remove('pcs__cart-btn--success');
              addToCartBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> <span>' + escapeHtml(t.add_to_cart) + '</span> <span class="pcs__cart-btn-price">' + formatMoney(cartBtnTotalPrice) + '</span>';
            }, 2000);

            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var cartEvent = new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    sourceId: 'pcs-' + config.sectionId,
                    data: {
                      itemCount: cart.item_count,
                      source: 'pcs-configurator'
                    }
                  }
                });
                document.dispatchEvent(cartEvent);

                var countEls = document.querySelectorAll('.cart-count, [data-cart-count]');
                countEls.forEach(function (el) { el.textContent = cart.item_count; });

                var bubbleCount = document.querySelector('[ref="cartBubbleCount"]');
                if (bubbleCount) bubbleCount.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
                var bubble = document.querySelector('[ref="cartBubble"]');
                if (bubble) {
                  bubble.classList.remove('visually-hidden');
                  bubble.classList.add('cart-bubble--animating');
                  setTimeout(function () { bubble.classList.remove('cart-bubble--animating'); }, 600);
                }
                var cartIcon = document.querySelector('cart-icon');
                if (cartIcon) cartIcon.classList.add('header-actions__cart-icon--has-cart');
              });
          }
        })
        .catch(function (err) {
          console.error('Cart error:', err);
          alert(t.error_occurred);
        })
        .finally(function () {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('pcs__cart-btn--loading');
        });
    }

    /* ── Event Binding ── */
    function bindEvents() {
      nextBtn.addEventListener('click', nextStep);
      backBtn.addEventListener('click', prevStep);
      if (cartBackBtn) cartBackBtn.addEventListener('click', prevStep);
      if (addToCartBtn) addToCartBtn.addEventListener('click', addToCart);

      progressDots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(this.getAttribute('data-pcs-progress-dot'));
          if (stepEnabled[idx] && (idx <= currentStepIdx || selections[steps[idx].name] !== undefined)) {
            goToStep(idx);
          }
        });
      });

      sectionEl.addEventListener('input', function (e) {
        if (e.target.matches('[data-slider-range]')) handleSliderRange(e.target);
      });

      sectionEl.addEventListener('change', function (e) {
        if (e.target.matches('[data-slider-range]')) handleSliderCommit(e.target);
        if (e.target.matches('[data-slider-number]')) handleSliderNumberCommit(e.target);
        if (e.target.matches('[data-checkbox-input]')) handleCheckbox(e.target);
      });

      sectionEl.addEventListener('click', function (e) {
        var colorBtn = e.target.closest('[data-color-value]');
        if (colorBtn) { handleColorSelect(colorBtn); return; }

        var zoomTrigger = e.target.closest('[data-pcs-fabric-zoom]') || e.target.closest('[data-pcs-imgselect-zoom]');
        if (zoomTrigger) { openFabricLightbox(zoomTrigger); return; }

        var imgSelBtn = e.target.closest('[data-imgselect-value]');
        if (imgSelBtn) { handleImgSelectOption(imgSelBtn); return; }

        var fabricBtn = e.target.closest('[data-fabric-value]');
        if (fabricBtn) { handleFabricSelect(fabricBtn); return; }

        var selectBtn = e.target.closest('[data-select-value]');
        if (selectBtn && !selectBtn.disabled) { handleSelectOption(selectBtn); return; }

        var surchargeToggle = e.target.closest('[data-pcs-surcharge-toggle]');
        if (surchargeToggle) { handleSurchargeToggle(surchargeToggle); return; }

        var modalClose = e.target.closest('[data-pcs-surcharge-modal-close]');
        if (modalClose) { closeSurchargeModal(); return; }
      });
    }

    /* ── Handlers ── */
    function handleSliderRange(input) {
      var stepEl = input.closest('[data-pcs-step]');
      var stepIdx = parseInt(stepEl.getAttribute('data-pcs-step'));
      var val = parseInt(input.value);
      var display = stepEl.querySelector('[data-slider-display]');
      var numInput = stepEl.querySelector('[data-slider-number]');
      if (display) display.textContent = val;
      if (numInput) numInput.value = val;
      selections[steps[stepIdx].name] = val;
      updateSliderFill(input);
    }

    function snapToStep(val, min, max, inc) {
      if (inc > 1) {
        val = Math.round((val - min) / inc) * inc + min;
      }
      return Math.max(min, Math.min(max, val));
    }

    function handleSliderNumberCommit(input) {
      var stepEl = input.closest('[data-pcs-step]');
      var stepIdx = parseInt(stepEl.getAttribute('data-pcs-step'));
      var step = steps[stepIdx];
      var raw = input.value.trim();
      if (raw === '') {
        input.value = selections[step.name] || step.min;
        return;
      }
      var val = parseInt(raw);
      if (isNaN(val)) {
        input.value = selections[step.name] || step.min;
        return;
      }
      val = snapToStep(val, step.min, step.max, step.increment);
      input.value = val;
      var display = stepEl.querySelector('[data-slider-display]');
      var rangeInput = stepEl.querySelector('[data-slider-range]');
      if (display) display.textContent = val;
      if (rangeInput) { rangeInput.value = val; updateSliderFill(rangeInput); }
      selections[step.name] = val;
      evaluateAllConditions();
      updatePrice();
      showMediaBySelections();
    }

    function handleSliderCommit(input) {
      var stepEl = input.closest('[data-pcs-step]');
      var stepIdx = parseInt(stepEl.getAttribute('data-pcs-step'));
      var step = steps[stepIdx];
      var val = parseInt(input.value);
      if (isNaN(val)) return;
      val = snapToStep(val, step.min, step.max, step.increment);
      input.value = val;
      var display = stepEl.querySelector('[data-slider-display]');
      var numInput = stepEl.querySelector('[data-slider-number]');
      var rangeInput = stepEl.querySelector('[data-slider-range]');
      if (display) display.textContent = val;
      if (input.matches('[data-slider-number]') && rangeInput) {
        rangeInput.value = val; updateSliderFill(rangeInput);
      }
      if (input.matches('[data-slider-range]') && numInput) {
        numInput.value = val;
      }
      selections[step.name] = val;
      evaluateAllConditions();
      updatePrice();
    }

    function updateSliderFill(rangeInput) {
      var min = parseFloat(rangeInput.min);
      var max = parseFloat(rangeInput.max);
      var val = parseFloat(rangeInput.value);
      var pct = max > min ? ((val - min) / (max - min)) * 100 : 0;
      rangeInput.style.setProperty('--pcs-fill', pct + '%');
    }

    function handleColorSelect(btn) {
      var stepEl = btn.closest('[data-pcs-step]');
      var stepIdx;

      if (stepEl) {
        stepIdx = parseInt(stepEl.getAttribute('data-pcs-step'));
      } else if (surchargeModalStepIdx !== null) {
        stepIdx = surchargeModalStepIdx;
        stepEl = sectionEl.querySelector('[data-pcs-step="' + stepIdx + '"]');
      } else {
        return;
      }

      var val = btn.getAttribute('data-color-value');

      stepEl.querySelectorAll('[data-color-value]').forEach(function (b) {
        b.classList.remove('pcs__color-btn--selected');
      });
      if (activeSurchargeModal) {
        activeSurchargeModal.querySelectorAll('[data-color-value]').forEach(function (b) {
          b.classList.remove('pcs__color-btn--selected');
        });
      }
      btn.classList.add('pcs__color-btn--selected');
      selections[steps[stepIdx].name] = val;

      var isSurcharge = btn.getAttribute('data-color-group') === 'surcharge';
      var preview = stepEl.querySelector('[data-pcs-surcharge-selected]');
      if (preview) {
        if (isSurcharge) {
          var swatch = preview.querySelector('[data-pcs-surcharge-swatch]');
          var nameEl = preview.querySelector('[data-pcs-surcharge-name]');
          if (swatch) {
            var srcCircle = btn.querySelector('[data-color-bg]');
            if (srcCircle) {
              swatch.style.backgroundColor = srcCircle.style.backgroundColor;
              swatch.textContent = srcCircle.textContent || '';
              swatch.className = srcCircle.className.replace('pcs__color-circle', 'pcs__surcharge-selected-swatch');
            }
          }
          if (nameEl) nameEl.textContent = val;
          preview.hidden = false;
        } else {
          preview.hidden = true;
        }
      }

      var colorStep = steps[stepIdx];
      if (isSurcharge && colorStep.colorOptions && colorStep.colorOptions.optis) {
        setOptisPrice(colorStep.name, colorStep.colorOptions.optis, val);
      } else {
        clearOptisPrice(colorStep.name);
      }

      if (activeSurchargeModal) closeSurchargeModal();

      evaluateAllConditions();
      updatePrice();
      showMediaBySelections();
    }

    function handleFabricSelect(btn) {
      var stepEl = btn.closest('[data-pcs-step]');
      var stepIdx = parseInt(stepEl.getAttribute('data-pcs-step'));
      var val = btn.getAttribute('data-fabric-value');

      stepEl.querySelectorAll('[data-fabric-value]').forEach(function (b) {
        b.classList.remove('pcs__fabric-btn--selected');
      });
      btn.classList.add('pcs__fabric-btn--selected');
      selections[steps[stepIdx].name] = val;

      var step = steps[stepIdx];
      var optis = null;
      if (step.fabricOptionList) {
        for (var j = 0; j < step.fabricOptionList.length; j++) {
          var f = step.fabricOptionList[j];
          if ((f.value || f.name || f.label) === val) {
            optis = f.optis;
            break;
          }
        }
      }
      if (optis) {
        setOptisPrice(step.name, optis);
      } else {
        clearOptisPrice(step.name);
      }

      evaluateAllConditions();
      updatePrice();
      showMediaBySelections();
    }

    function handleImgSelectOption(btn) {
      var stepEl = btn.closest('[data-pcs-step]');
      var stepIdx = parseInt(stepEl.getAttribute('data-pcs-step'));
      var val = btn.getAttribute('data-imgselect-value');

      stepEl.querySelectorAll('[data-imgselect-value]').forEach(function (b) {
        b.classList.remove('pcs__imgselect-btn--selected');
      });
      btn.classList.add('pcs__imgselect-btn--selected');
      selections[steps[stepIdx].name] = val;

      var step = steps[stepIdx];
      var optis = null;
      if (step.imageOptions) {
        for (var j = 0; j < step.imageOptions.length; j++) {
          if ((step.imageOptions[j].value || step.imageOptions[j].name) === val) {
            optis = step.imageOptions[j].optis;
            break;
          }
        }
      }
      if (optis) {
        setOptisPrice(step.name, optis);
      } else {
        clearOptisPrice(step.name);
      }

      evaluateAllConditions();
      updatePrice();
      showMediaBySelections();
    }

    function handleSelectOption(btn) {
      var stepEl = btn.closest('[data-pcs-step]');
      var stepIdx = parseInt(stepEl.getAttribute('data-pcs-step'));
      var val = btn.getAttribute('data-select-value');

      stepEl.querySelectorAll('[data-select-value]').forEach(function (b) {
        b.classList.remove('pcs__select-btn--selected');
      });
      btn.classList.add('pcs__select-btn--selected');
      selections[steps[stepIdx].name] = val;

      var step = steps[stepIdx];
      var optis = null;
      if (step.optionList) {
        for (var j = 0; j < step.optionList.length; j++) {
          if ((step.optionList[j].value || step.optionList[j].name) === val) {
            optis = step.optionList[j].optis;
            break;
          }
        }
      }
      if (optis) {
        setOptisPrice(step.name, optis);
      } else {
        clearOptisPrice(step.name);
      }

      evaluateAllConditions();
      updatePrice();
      showMediaBySelections();
    }

    function handleCheckbox(input) {
      var stepEl = input.closest('[data-pcs-step]');
      var stepIdx = parseInt(stepEl.getAttribute('data-pcs-step'));
      var val = input.checked ? 'Yes' : 'No';
      var status = stepEl.querySelector('[data-checkbox-status]');
      if (status) status.textContent = input.checked ? t.yes : t.no;
      selections[steps[stepIdx].name] = val;
      evaluateAllConditions();
      updatePrice();
      showMediaBySelections();
    }

    var activeSurchargeModal = null;
    var surchargeModalPlaceholder = null;
    var surchargeModalStepIdx = null;

    function handleSurchargeToggle(btn) {
      var stepEl = btn.closest('[data-pcs-step]');
      var modal = stepEl.querySelector('[data-pcs-surcharge-modal]');
      if (!modal) return;

      surchargeModalStepIdx = parseInt(stepEl.getAttribute('data-pcs-step'));
      surchargeModalPlaceholder = document.createComment('surcharge-modal');
      modal.parentNode.insertBefore(surchargeModalPlaceholder, modal);
      document.body.appendChild(modal);
      activeSurchargeModal = modal;

      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('pcs__surcharge-modal--open'); });
      document.body.style.overflow = 'hidden';
    }

    function closeSurchargeModal() {
      var modal = activeSurchargeModal;
      if (!modal) return;
      modal.classList.remove('pcs__surcharge-modal--open');
      document.body.style.overflow = '';
      setTimeout(function () {
        modal.hidden = true;
        if (surchargeModalPlaceholder && surchargeModalPlaceholder.parentNode) {
          surchargeModalPlaceholder.parentNode.insertBefore(modal, surchargeModalPlaceholder);
          surchargeModalPlaceholder.parentNode.removeChild(surchargeModalPlaceholder);
        }
        activeSurchargeModal = null;
        surchargeModalPlaceholder = null;
        surchargeModalStepIdx = null;
      }, 250);
    }

    document.addEventListener('click', function (e) {
      if (!activeSurchargeModal) return;

      var closeBtn = e.target.closest('[data-pcs-surcharge-modal-close]');
      if (closeBtn) { closeSurchargeModal(); return; }

      var colorBtn = e.target.closest('[data-color-value]');
      if (colorBtn && activeSurchargeModal.contains(colorBtn)) {
        handleColorSelect(colorBtn);
        return;
      }
    });

    /* ── Gallery (single image display) ── */
    var galleryEl = sectionEl.querySelector('[data-pcs-gallery]');
    var displayImg = galleryEl ? galleryEl.querySelector('[data-pcs-display-img]') : null;
    var mediaList = config.media || [];
    var currentMediaIdx = 0;

    var galleryLoader = galleryEl ? galleryEl.querySelector('[data-pcs-gallery-loader]') : null;

    function showMedia(idx) {
      if (!displayImg || idx < 0 || idx >= mediaList.length || idx === currentMediaIdx) return;
      var m = mediaList[idx];
      var src = m.mediaType === 'image' ? m.src : (m.previewSrc || m.src);
      currentMediaIdx = idx;
      if (galleryLoader) galleryLoader.hidden = false;
      var tempImg = new Image();
      tempImg.onload = function () {
        displayImg.src = src;
        displayImg.alt = m.alt || '';
        if (galleryLoader) galleryLoader.hidden = true;
      };
      tempImg.src = src;
    }

    function parseAltPairs(alt) {
      if (!alt) return null;
      var pairs = {};
      var parts = alt.split(',');
      var valid = false;
      for (var i = 0; i < parts.length; i++) {
        var eqIdx = parts[i].indexOf('=');
        if (eqIdx < 1) continue;
        var k = parts[i].substring(0, eqIdx).trim().toLowerCase();
        var v = parts[i].substring(eqIdx + 1).trim().toLowerCase();
        if (k) { pairs[k] = v; valid = true; }
      }
      return valid ? pairs : null;
    }

    function findStepByAltKey(altKey) {
      var lk = altKey.toLowerCase();
      for (var s = 0; s < steps.length; s++) {
        if (steps[s].name.toLowerCase() === lk) return steps[s];
        if (steps[s].key && steps[s].key.toLowerCase() === lk) return steps[s];
      }
      return null;
    }

    function getOptionDisplayValues(step, val) {
      var results = [String(val).toLowerCase().trim()];
      var name = getOptionNameForValue(step.name, val);
      if (name !== val) results.push(String(name).toLowerCase().trim());
      if (step.type === 'Fabric') {
        var stripped = stripFabricLevel(String(val)).toLowerCase().trim();
        if (results.indexOf(stripped) === -1) results.push(stripped);
        var strippedName = stripFabricLevel(String(name)).toLowerCase().trim();
        if (results.indexOf(strippedName) === -1) results.push(strippedName);
      }
      if (step.type === 'Select' && step.optionList) {
        for (var j = 0; j < step.optionList.length; j++) {
          var o = step.optionList[j];
          if ((o.value || o.name) === val || o.name === val) {
            if (o.displayName && results.indexOf(o.displayName.toLowerCase().trim()) === -1)
              results.push(o.displayName.toLowerCase().trim());
          }
        }
      } else if (step.type === 'Select With Image' && step.imageOptions) {
        for (var j = 0; j < step.imageOptions.length; j++) {
          var o = step.imageOptions[j];
          if ((o.value || o.name) === val || o.name === val) {
            if (o.displayName && results.indexOf(o.displayName.toLowerCase().trim()) === -1)
              results.push(o.displayName.toLowerCase().trim());
          }
        }
      } else if (step.type === 'Fabric' && step.fabricOptionList) {
        for (var j = 0; j < step.fabricOptionList.length; j++) {
          var f = step.fabricOptionList[j];
          if ((f.value || f.name || f.label) === val || f.name === val || f.label === val) {
            if (f.label && results.indexOf(f.label.toLowerCase().trim()) === -1)
              results.push(f.label.toLowerCase().trim());
            if (f.displayName && results.indexOf(f.displayName.toLowerCase().trim()) === -1)
              results.push(f.displayName.toLowerCase().trim());
          }
        }
      }
      return results;
    }

    function showMediaBySelections() {
      if (!displayImg || mediaList.length === 0) return;

      var bestIdx = -1;
      var bestScore = 0;

      for (var i = 0; i < mediaList.length; i++) {
        var pairs = parseAltPairs(mediaList[i].alt);
        if (!pairs) continue;

        var keys = Object.keys(pairs);
        var matched = 0;
        var allMatch = true;

        for (var k = 0; k < keys.length; k++) {
          var altKey = keys[k];
          var altVal = pairs[altKey];
          var step = findStepByAltKey(altKey);

          if (!step) { allMatch = false; continue; }

          var selVal = selections[step.name];
          if (selVal === undefined || selVal === null) { allMatch = false; continue; }

          var possibleVals = getOptionDisplayValues(step, selVal);
          if (possibleVals.indexOf(altVal) > -1) {
            matched++;
          } else {
            allMatch = false;
          }
        }

        if (allMatch && matched > 0 && matched > bestScore) {
          bestScore = matched;
          bestIdx = i;
        }
      }

      if (bestIdx > -1) showMedia(bestIdx);
    }

    function updateGalleryForVariant(variant) {
      if (!variant || !variant.featured_image || !displayImg) return;
      var varSrc = variant.featured_image.src;
      if (!varSrc) return;
      var varFile = varSrc.split('?')[0].split('/').pop();
      for (var i = 0; i < mediaList.length; i++) {
        if (mediaList[i].src && mediaList[i].src.indexOf(varFile) > -1) {
          showMedia(i);
          return;
        }
      }
    }

    /* Fullscreen */
    var fullscreenBtn = galleryEl ? galleryEl.querySelector('[data-pcs-fullscreen]') : null;

    function openFullscreen() {
      if (!displayImg) return;
      var m = mediaList[currentMediaIdx];
      var src = m ? (m.srcLarge || m.src) : displayImg.src;
      var alt = m ? (m.alt || '') : (displayImg.alt || '');

      var overlay = document.createElement('div');
      overlay.className = 'pcs__media-fullscreen';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('tabindex', '-1');

      overlay.innerHTML =
        '<div class="pcs__media-fullscreen-backdrop"></div>' +
        '<div class="pcs__media-fullscreen-content">' +
          '<button class="pcs__media-fullscreen-close" type="button" aria-label="Close">' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<img class="pcs__media-fullscreen-img" src="' + src + '" alt="' + escapeHtml(alt) + '">' +
        '</div>';

      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () { overlay.classList.add('pcs__media-fullscreen--open'); });

      function closeFs() {
        overlay.classList.remove('pcs__media-fullscreen--open');
        setTimeout(function () {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
          document.body.style.overflow = '';
        }, 250);
      }

      overlay.querySelector('.pcs__media-fullscreen-close').addEventListener('click', closeFs);
      overlay.querySelector('.pcs__media-fullscreen-backdrop').addEventListener('click', closeFs);
      overlay.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFs(); });
      overlay.focus();
    }

    if (fullscreenBtn) fullscreenBtn.addEventListener('click', openFullscreen);
    if (displayImg) displayImg.addEventListener('click', openFullscreen);

    /* ── Init sliders fill on load ── */
    function initSliderFills() {
      sectionEl.querySelectorAll('[data-slider-range]').forEach(function (input) {
        updateSliderFill(input);
      });
    }

    /* ── Product Tabs ── */
    function initTabs() {
      var tabsEl = sectionEl.querySelector('[data-pcs-tabs]');
      if (!tabsEl) return;

      var tabBtns = tabsEl.querySelectorAll('[data-pcs-tab]');
      var tabPanels = tabsEl.querySelectorAll('[data-pcs-panel]');

      tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tabId = this.getAttribute('data-pcs-tab');

          tabBtns.forEach(function (b) {
            b.classList.remove('pcs__tabs-btn--active');
            b.setAttribute('aria-selected', 'false');
          });

          tabPanels.forEach(function (p) {
            p.classList.remove('pcs__tabs-panel--active');
          });

          this.classList.add('pcs__tabs-btn--active');
          this.setAttribute('aria-selected', 'true');

          var target = tabsEl.querySelector('[data-pcs-panel="' + tabId + '"]');
          if (target) target.classList.add('pcs__tabs-panel--active');
        });
      });
    }

    (function initFabricInfoHover() {
      sectionEl.querySelectorAll('[data-pcs-fabric-info]').forEach(function (infoEl) {
        var wrap = infoEl.closest('.pcs__fabric-img-wrap');
        if (!wrap) return;
        var feature = wrap.querySelector('[data-pcs-fabric-feature]');
        if (!feature) return;

        infoEl.addEventListener('mouseenter', function () {
          feature.classList.add('pcs__fabric-feature--visible');
        });
        infoEl.addEventListener('mouseleave', function () {
          setTimeout(function () {
            if (!feature.matches(':hover')) {
              feature.classList.remove('pcs__fabric-feature--visible');
            }
          }, 100);
        });
        feature.addEventListener('mouseleave', function () {
          if (!infoEl.matches(':hover')) {
            feature.classList.remove('pcs__fabric-feature--visible');
          }
        });
      });
    })();

    function openFabricLightbox(zoomEl) {
      var src = zoomEl.getAttribute('data-pcs-fabric-zoom') || zoomEl.getAttribute('data-pcs-imgselect-zoom');
      var label = zoomEl.getAttribute('data-pcs-fabric-label') || zoomEl.getAttribute('data-pcs-imgselect-label') || '';
      if (!src) return;

      var overlay = document.createElement('div');
      overlay.className = 'pcs__fabric-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('tabindex', '-1');

      overlay.innerHTML =
        '<div class="pcs__fabric-lightbox-backdrop"></div>' +
        '<div class="pcs__fabric-lightbox-content">' +
          '<button class="pcs__fabric-lightbox-close" type="button" aria-label="Close">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<img class="pcs__fabric-lightbox-img" src="' + src + '" alt="' + escapeHtml(label) + '">' +
          (label ? '<p class="pcs__fabric-lightbox-label">' + escapeHtml(label) + '</p>' : '') +
        '</div>';

      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () { overlay.classList.add('pcs__fabric-lightbox--open'); });

      function closeLightbox() {
        overlay.classList.remove('pcs__fabric-lightbox--open');
        setTimeout(function () {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
          document.body.style.overflow = '';
        }, 250);
      }

      overlay.querySelector('.pcs__fabric-lightbox-close').addEventListener('click', closeLightbox);
      overlay.querySelector('.pcs__fabric-lightbox-backdrop').addEventListener('click', closeLightbox);
      overlay.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLightbox();
      });
      overlay.focus();
    }

    init();
    initSliderFills();
    initTabs();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pcs-config]').forEach(function (configEl) {
      var config;
      try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
      var sectionEl = document.querySelector('[data-pcs-section][data-section-id="' + config.sectionId + '"]');
      if (!sectionEl) return;
      initPCS(sectionEl, config);
    });
  });
})();
